<template lang="jade">
  button.btn(type='button', v-link="pathObj", @click='clickF')
    i.fa.fa-angle-left.fa-2x(aria-hidden='true', :class="{ 'fa-rotate-90': directionTop}")
    span {{title}}
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    title: {
      type: String,
      required: true
    },
    path: {
      type: String,
      // required: true
    },
    clickFunc: {
      type: Function
    },
    directionTop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pathObj () {
      return {
        path: this.path
      }
    }
  },
  ready () {},
  attached () {},
  methods: {
    clickF(e) {
      if (this.clickFunc) {
        this.clickFunc()
        e.preventDefault()
      }
    }
  },
  components: {}
}
</script>

<style lang="scss">
button.btn {
  display: flex;
  font-weight: bold;
  background:none;
  display: flex;
  font-size: 14px;
  span {
    line-height: 2em;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// back-button.vue?552c034c